"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupTxnListByString = exports.groupTxnListByAmount = exports.groupTxnListByDate = void 0;
const luxon_1 = require("luxon");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
// Used by TXList selector to create date groups for register display
function groupTxnListByDate(txns, featureFlags, showPendingSection = true) {
    const today = luxon_1.DateTime.local().startOf('day');
    const groupsOfTransactions = txns.groupBy((txn) => {
        const tDate = luxon_1.DateTime.fromISO(txn.postedOn).startOf('day');
        let ret;
        const isFuture = (tDate > today) && featureFlags.get('labelPendingAsFuture');
        const isPending = isFuture || (txn.state === 'PENDING' && featureFlags.get('manualArePending'));
        // Pending
        if (showPendingSection && isPending) {
            ret = featureFlags.get('labelPendingAsFuture') ? '9999-99:Future' : '9999-99:Pending';
            // within past 24 months
        }
        else if (tDate > today.minus({ months: 24 })) {
            ret = `${tDate.toFormat('yyyy-MM:MMMM yyyy')}`;
        }
        else {
            // group the rest by year
            ret = `${tDate.toFormat('yyyy-00:yyyy')}`;
        }
        return ret;
    });
    return groupsOfTransactions;
}
exports.groupTxnListByDate = groupTxnListByDate;
const expenseSectionTitle = 'Money Out';
const incomeSectionTitle = 'Money In';
// Used by TXList selector to create amount groups for register display
function groupTxnListByAmount(txns) {
    const groupsOfTransactions = txns.groupBy((txn) => {
        const amount = Number(txn.amount);
        let ret;
        switch (true) {
            case (amount >= -20) && (amount < 0):
                ret = `00:${expenseSectionTitle} 0 - 20`;
                break;
            case (amount >= -50) && (amount < -20):
                ret = `00:${expenseSectionTitle} 20 - 50`;
                break;
            case (amount >= -100) && (amount < -50):
                ret = `00:${expenseSectionTitle} 50 - 100`;
                break;
            case (amount >= -300) && (amount < -100):
                ret = `00:${expenseSectionTitle} 100 - 300`;
                break;
            case (amount >= -500) && (amount < -300):
                ret = `00:${expenseSectionTitle} 300 - 500`;
                break;
            case (amount >= -1000) && (amount < -500):
                ret = `00:${expenseSectionTitle} 500 - 1000`;
                break;
            case (amount >= -3000) && (amount < -1000):
                ret = `00:${expenseSectionTitle} 1000 - 3000`;
                break;
            case (amount >= -10000) && (amount < -3000):
                ret = `00:${expenseSectionTitle} 3000 - 10000`;
                break;
            case amount < -10000:
                ret = `00:${expenseSectionTitle} over 10000`;
                break;
            case (amount >= 0) && (amount < 100):
                ret = `00:${incomeSectionTitle} 0 - 100`;
                break;
            case (amount >= 100) && (amount < 500):
                ret = `00:${incomeSectionTitle} 100 - 500`;
                break;
            case (amount >= 500) && (amount < 1000):
                ret = `00:${incomeSectionTitle} 500 - 1000`;
                break;
            case (amount >= 1000) && (amount < 5000):
                ret = `00:${incomeSectionTitle} 1000 - 5000`;
                break;
            case amount >= 5000:
                ret = `00:${incomeSectionTitle} over 5000`;
                break;
            default:
                ret = '14:Other';
                break;
        }
        return ret;
    });
    return groupsOfTransactions;
}
exports.groupTxnListByAmount = groupTxnListByAmount;
// Used by TXList selector to create groups grouped alphabetically for register display
function groupTxnListByString(txns, field) {
    const groupsOfTransactions = txns.groupBy((txn) => {
        var _a, _b, _c;
        let startsWith;
        let strValue;
        switch (field) {
            case 'check':
                strValue = txn.check ? String(txn.check.number) : ' ';
                startsWith = (_a = strValue.charAt(0)) === null || _a === void 0 ? void 0 : _a.toLowerCase();
                break;
            case 'category':
                strValue = txn.coa ? chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, txn.coa, true) : ' ';
                startsWith = (_b = strValue.charAt(0)) === null || _b === void 0 ? void 0 : _b.toLowerCase();
                break;
            default:
                strValue = txn.get(field);
                if (strValue && (strValue === null || strValue === void 0 ? void 0 : strValue.length) > 0) {
                    startsWith = (_c = strValue.charAt(0)) === null || _c === void 0 ? void 0 : _c.toLowerCase();
                }
                else {
                    startsWith = ' ';
                }
        }
        let ret;
        strValue = strValue || ' ';
        switch (true) {
            case (strValue === null || strValue === void 0 ? void 0 : strValue.toLowerCase()) === 'future':
                ret = '00:FUTURE';
                break;
            case (strValue === null || strValue === void 0 ? void 0 : strValue.toLowerCase()) === 'pending':
                ret = '00:Uncleared';
                break;
            case (strValue === null || strValue === void 0 ? void 0 : strValue.toLowerCase()) === 'cleared':
                ret = '00:Cleared';
                break;
            case (strValue === null || strValue === void 0 ? void 0 : strValue.toLowerCase()) === 'reconciled':
                ret = '00:Reconciled';
                break;
            case startsWith >= 'a' && startsWith <= 'd':
                ret = '00:A - D';
                break;
            case startsWith >= 'e' && startsWith <= 'h':
                ret = '01:E - H';
                break;
            case startsWith >= 'i' && startsWith <= 'l':
                ret = '02:I - L';
                break;
            case startsWith >= 'm' && startsWith <= 'p':
                ret = '03:M - P';
                break;
            case startsWith >= 'q' && startsWith <= 't':
                ret = '04:Q - T';
                break;
            case startsWith >= 'u' && startsWith <= 'z':
                ret = '05:U - Z';
                break;
            case startsWith >= '0' && startsWith <= '9':
                ret = '06:Numbers';
                break;
            default:
                ret = '07:Other';
                break;
        }
        return ret;
    });
    return groupsOfTransactions;
}
exports.groupTxnListByString = groupTxnListByString;
